module.exports = ".collapseShow {\n    display: none !important;\n}\n\n.collapseHidden {\n    display: none !important;\n}\n\n/* .hide-me[aria-expanded=\"true\"] {display: none;} */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/projects/projects.component.css
// module id = ./src/app/views/projects/projects.component.css
// module chunks = main